import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { FlexEdModalComponent } from './components/flex-ed-modal/flex-ed-modal.component';
import { FlexEdTransactionsComponent } from './components/flex-ed-transactions/flex-ed-transactions.component';
import { FlexEdViewComponent } from './components/flex-ed-view/flex-ed-view.component';

@NgModule({
  declarations: [
    FlexEdViewComponent,
    FlexEdModalComponent,
    FlexEdTransactionsComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class FlexEdModule {}
